const valueOf = Symbol.prototype.valueOf;

export function cloneSymbol(value: symbol): symbol {
  return valueOf ? Object(valueOf.call(value)) : {};
}
